import React from 'react';
import Link from 'next/link';
import styled, { css } from 'styled-components';
import MuiBreadcrumbs from '@material-ui/core/Breadcrumbs';
import HomeIcon from '../../../public/asset/homeIcon.svg';
import { IBreadCrumb } from './IBreadCrumbCmp';
import { capitalize } from '@/utils/index';
import Typography from '../Typography';

interface IStyledProps {
  active?: boolean;
  size?: string;
}

const StyledLink = styled.a<IStyledProps>`
  color: ${props => props.theme.paletteDefault.grey1};
  display: flex;
`;

const Container = styled.div`
  svg {
    path:first-child {
      fill: ${props => props.theme.paletteDefault.offWhite};
    }
  }
`;

const CustomMuiBreadcrumbs = styled(MuiBreadcrumbs)<IStyledProps>`
  & .MuiBreadcrumbs-separator {
    color: ${props => props.theme.paletteDefault.grey1};
  }
  ${props =>
    props.size === 'small' &&
    css`
      &.MuiTypography-body1 {
        font-size: 14px;
        color: ${props => props.theme.paletteDefault.grey1};
      }
    `}
`;
const Breadcrumb: React.FC<IBreadCrumb> = ({
  tokens,
  homeIcon = true,
  size,
}) => {
  const links = tokens.map((token, index, array) => {
    return (
      <Link
        key={`bread-${token.label}`}
        href={token.href}
        passHref
        shallow={true}>
        <StyledLink active={index === array.length - 1}>
          {homeIcon && index === 0 ? (
            <HomeIcon />
          ) : (
            <Typography datatype="caption">
              {capitalize(token.label)}
            </Typography>
          )}
        </StyledLink>
      </Link>
    );
  });

  return (
    <Container>
      <CustomMuiBreadcrumbs size={size}>{links}</CustomMuiBreadcrumbs>
    </Container>
  );
};

export default Breadcrumb;
